<mat-toolbar [ngClass]="{ 'mat-elevation-z1': !(isHandheld$ | async), 'mat-toolbar-testing-envir': !(environment.production) }" color="primary">
  @if (isHandheld$ | async) {
    <button mat-icon-button (click)="onMenuClick()" class="menu-button" [attr.aria-label]="sysText?.menu_ariaLabel">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <!-- h1: the page's top heading (its look comes from the classes, so the tag doesn't change it) -->
  <h1 class="header-title subtitle1">{{ title$ | async | titlecase }}
    @if ((environment.installBanner.length > 0) && (title$ | async)) {
      <span>{{ environment.installBanner }}</span>
    }
  </h1>
  <span class="spacer"></span>
  <!-- the spinner shows inside the button while its drawer loads, so the button (and focus) stays put -->
  @if (showEmailButton$ | async) {
    <button mat-icon-button (click)="onEmailClick()" class="menu-button" [attr.aria-label]="sysText?.caseEmail_ariaLabel">
      @if (caseComIsLoading$ | async) {
        <mat-spinner diameter="25" color="accent" [attr.aria-label]="sysText?.loading_ariaLabel"></mat-spinner>
      } @else {
        <mat-icon>email</mat-icon>
      }
    </button>
  }
  <button mat-icon-button (click)="onHelpClick()" class="menu-button" [attr.aria-label]="sysText?.help_ariaLabel">
    @if (helpIsLoading$ | async) {
      <mat-spinner diameter="25" color="accent" [attr.aria-label]="sysText?.loading_ariaLabel"></mat-spinner>
    } @else {
      <mat-icon>help</mat-icon>
    }
  </button>
  @if (showExpandCollapseAllButtons$ | async) {
    <div class="arrow-button-container">
      <button type="button" class="button-reset" [attr.aria-label]="sysText?.collapseAll_ariaLabel" (click)="onCollapseAll($event)">
        <mat-icon
          class="header-button header-button-double-arrow mat-icon-hover-highlight">
          keyboard_double_arrow_up
        </mat-icon>
      </button>
      <button type="button" class="button-reset" [attr.aria-label]="sysText?.expandAll_ariaLabel" (click)="onExpandAll($event)">
        <mat-icon
          class="header-button header-button-double-arrow mat-icon-hover-highlight">
          keyboard_double_arrow_down
        </mat-icon>
      </button>
    </div>
  }
</mat-toolbar>

